<template>
  <v-container id="user-profile" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" lg="10">
        <base-material-card>
          <template v-slot:heading>
            <div class="display-2 font-weight-light">
              {{
              id ? $i18n.t("Edit shift - ") + shift.name : $i18n.t("Create shift")
              }}
            </div>
          </template>

          <v-form id="form" ref="form" v-model="valid">
            <v-container class="py-0">
              <v-row>
                <v-col cols="4" style="margin-top:17px">
                  <v-text-field
                    :label="$i18n.t('Work Shift Name')"
                    :rules="validationrules.name"
                    required
                    dense
                    v-model="shift.name"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <z-time-picker
                    :label="$i18n.t('Start Time')"
                    v-model="shift.startTime"
                    :rules="validationrules.startTime"
                    required
                  ></z-time-picker>
                </v-col>
                <v-col cols="4">
                  <z-time-picker
                    :label="$i18n.t('End Time')"
                    :rules="validationrules.endTime"
                    v-model="shift.endTime"
                    required
                  ></z-time-picker>
                </v-col>
              </v-row>
            </v-container>
            <v-container class="py-0">
              <v-row style="margin-left:10px">
                <v-chip
                  @click="shift.su = !shift.su"
                  class="ma-1 week-button"
                  label
                  color="info"
                  text-color="white"
                  v-if="shift.su"
                >SU</v-chip>
                <v-chip
                  @click="shift.su = !shift.su"
                  class="ma-1 week-button"
                  label
                  color="grey"
                  text-color="black"
                  v-else
                >SU</v-chip>

                <v-chip
                  @click="shift.mo = !shift.mo"
                  class="ma-1 week-button"
                  label
                  color="info"
                  text-color="white"
                  v-if="shift.mo"
                >MO</v-chip>
                <v-chip
                  @click="shift.mo = !shift.mo"
                  class="ma-1 week-button"
                  label
                  color="grey"
                  text-color="black"
                  v-else
                >MO</v-chip>

                <v-chip
                  @click="shift.tu = !shift.tu"
                  class="ma-1 week-button"
                  label
                  color="info"
                  text-color="white"
                  v-if="shift.tu"
                >TU</v-chip>
                <v-chip
                  @click="shift.tu = !shift.tu"
                  class="ma-1 week-button"
                  label
                  color="grey"
                  text-color="black"
                  v-else
                >TU</v-chip>

                <v-chip
                  @click="shift.we = !shift.we"
                  class="ma-1 week-button"
                  label
                  color="info"
                  text-color="white"
                  v-if="shift.we"
                >WE</v-chip>
                <v-chip
                  @click="shift.we = !shift.we"
                  class="ma-1 week-button"
                  label
                  color="grey"
                  text-color="black"
                  v-else
                >WE</v-chip>

                <v-chip
                  @click="shift.th = !shift.th"
                  class="ma-1 week-button"
                  label
                  color="info"
                  text-color="white"
                  v-if="shift.th"
                >TH</v-chip>
                <v-chip
                  @click="shift.th = !shift.th"
                  class="ma-1 week-button"
                  label
                  color="grey"
                  text-color="black"
                  v-else
                >TH</v-chip>

                <v-chip
                  @click="shift.fr = !shift.fr"
                  class="ma-1 week-button"
                  label
                  color="info"
                  text-color="white"
                  v-if="shift.fr"
                >FR</v-chip>
                <v-chip
                  @click="shift.fr = !shift.fr"
                  class="ma-1 week-button"
                  label
                  color="grey"
                  text-color="black"
                  v-else
                >FR</v-chip>

                <v-chip
                  @click="shift.sa = !shift.sa"
                  class="ma-1 week-button"
                  label
                  color="info"
                  text-color="white"
                  v-if="shift.sa"
                >SA</v-chip>
                <v-chip
                  @click="shift.sa = !shift.sa"
                  class="ma-1 week-button"
                  label
                  color="grey"
                  text-color="black"
                  v-else
                >SA</v-chip>
              </v-row>
            </v-container>
            <v-col cols="12" class="text-right">
              <v-btn
                color="success"
                class="mr-0"
                @click="save()"
                :loading="loading"
                :disabled="!valid"
              >
                <h3>{{ $i18n.t("Save") }}</h3>
              </v-btn>
            </v-col>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Tickets extends Vue {
  valid = true;
  shift = {
    name: "",
    su: false,
    mo: true,
    tu: true,
    we: true,
    th: true,
    fr: true,
    sa: false,
    startTime: 9,
    endTime: 6,
    version: null,
    _id: null,
  };

  validationrules = {
    name: [(v) => !!v || this.$i18n.t("Name is required")],
    startTime: [(v) => !!v || this.$i18n.t("Start Time is required")],
    endTime: [(v) => !!v || this.$i18n.t("End Time is required")],
  };
  id = "";

  get loading() {
    return common.loading;
  }

  async save() {
    try {
      let time = this.shift.endTime - this.shift.startTime;
      if (time < 0) time = 24 + time;
      if (time > 11) {
        common.setError("shift time should not be more than 11hrs");
        return;
      }
      common.setLoading(true);
      this.shift = await doPost("/api/dutyhrs/saveUpdate", this.shift);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e);
      common.setLoading(false);
    }
  }

  async get(id) {
    try {
      this.shift = await doGet("/api/dutyhrs/" + id + "/detail");
    } catch (e) {
      common.setError(e.message);
    }
  }

  async mounted() {
    if (this.$route.params.id) {
      await this.get(this.$route.params.id);
    }
  }
}
</script>

<style scoped>
.week-button {
  padding: 5px 4px;
  height: 30px;
  width: 30px;
  justify-content: center;
}
</style>
